module.exports = __webpack_public_path__ + "img/grades.40880367.svg";